import { useSelector } from "react-redux";
import { RootState } from "../store";
import { AppState } from "../store/appSlice";

/**
 * Get current languages selection
 * @returns 
 */
export const useAppInfo = ():AppState => {
  return useSelector((state: RootState) => state.app);
}